import { getIsLoading } from '../Shared/selectors';

const getIsCUNotificationsShown = (state) =>
  state?.common?.isCUNotificationsShown;
const getCUNotifications = (state) =>
  state?.currentUserNotifications?.results || [];
const getCUNotificationsCount = (state) =>
  state?.currentUserNotifications?.count || 0;
const getCUNextNotifications = (state) => state?.currentUserNotifications?.next;
const getCUPrevNotifications = (state) =>
  state?.currentUserNotifications?.previous;

export {
  getIsCUNotificationsShown,
  getCUNotifications,
  getCUNotificationsCount,
  getCUNextNotifications,
  getCUPrevNotifications,
  getIsLoading,
};
